
import React from "react";
import { cn } from "@/lib/utils";

interface Props {
    className?: string;
    children: React.ReactNode;
}

const Wrapper = ({ children, className }: Props) => {
    return (
        <div
        className={cn(
            "size-full mx-auto container px-4 md:px-11",
            className
          )}
        >
            {children}
        </div>
    )
};

export default Wrapper
